import { render, staticRenderFns } from "./Anuncios.vue?vue&type=template&id=b4c72a56&scoped=true&"
import script from "./Anuncios.ts?vue&type=script&lang=ts&"
export * from "./Anuncios.ts?vue&type=script&lang=ts&"
import style0 from "./anuncios.scss?vue&type=style&index=0&id=b4c72a56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4c72a56",
  null
  
)

export default component.exports